// https://broadvoice-jira.atlassian.net/wiki/spaces/CJ/pages/2123923265/Glossary+Star+Codes
export const getBvCode = (inputNumber: string) =>
  inputNumber.replace(/\s/g, '').match(/^(Tran\*|\*)/)?.[0];
